/* eslint no-console:0 */

import 'jquery/dist/jquery.min';
import 'bootstrap/dist/js/bootstrap';
import 'stimulus';

console.log('Hello World from Webpacker')
